import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CurrencySelect } from "@/components/CurrencySelect";
import { PlayerBuyInSection } from "@/components/PlayerBuyInSection";
import { FinalChipsSection } from "@/components/FinalChipsSection";
import { TotalsBar } from "@/components/TotalsBar";
import { ErrorList } from "@/components/ErrorList";
import { SettlementResults } from "@/components/SettlementResults";
import { useCurrency } from "@/hooks/useCurrency";
import { usePlayersState } from "@/hooks/usePlayersState";
import { useSettlement } from "@/hooks/useSettlement";
import "./index.css";

export function App() {
  const currency = useCurrency();
  const players = usePlayersState();
  const settlement = useSettlement(players, currency);

  return (
    <div className="app-shell container mx-auto max-w-5xl p-2 md:p-8 relative z-10">
      <Card className="app-card py-4 md:py-6">
        <CardHeader className="app-header gap-3 px-4 md:px-6">
          <div className="flex items-start justify-between gap-3">
            <CardTitle className="app-title text-3xl font-bold">Poker Splitter</CardTitle>
            <CurrencySelect value={currency.selectedCurrency} onChange={currency.setSelectedCurrency} />
          </div>
        </CardHeader>
        <CardContent className="space-y-4 px-3 md:px-6">
          <PlayerBuyInSection
            players={players.players}
            currencySymbol={currency.currencySymbol}
            selectedCurrency={currency.selectedCurrency}
            cashInputValue={players.cashInputValue}
            beginCashEdit={players.beginCashEdit}
            changeCashEdit={players.changeCashEdit}
            endCashEdit={players.endCashEdit}
            chipInputValue={players.chipInputValue}
            beginChipEdit={players.beginChipEdit}
            changeChipEdit={players.changeChipEdit}
            endChipEdit={players.endChipEdit}
            updatePlayerName={players.updatePlayerName}
            removePlayer={players.removePlayer}
            pendingPlayerName={players.pendingPlayerName}
            setPendingPlayerName={players.setPendingPlayerName}
            commitPendingPlayer={players.commitPendingPlayer}
            suggestedCashIn={players.suggestedCashIn}
            suggestedChipsBought={players.suggestedChipsBought}
          />

          <FinalChipsSection
            visibleFinalPlayers={players.visibleFinalPlayers}
            hiddenFinalPlayers={players.hiddenFinalPlayers}
            players={players.players}
            chipInputValue={players.chipInputValue}
            beginChipEdit={players.beginChipEdit}
            changeChipEdit={players.changeChipEdit}
            endChipEdit={players.endChipEdit}
            hidePlayerFromFinalList={players.hidePlayerFromFinalList}
            restorePlayerToFinalList={players.restorePlayerToFinalList}
          />

          <div className="flex flex-wrap items-center gap-3">
            <Button type="button" className="app-cta" onClick={settlement.handleCalculate}>
              Calculate split
            </Button>
          </div>

          <TotalsBar totals={players.totalsPreview} formatCurrency={currency.formatCurrency} />
          <ErrorList errors={settlement.inputErrors} />

          {settlement.result ? (
            <SettlementResults
              result={settlement.result}
              chipValueDisplayUnit={players.chipValueDisplayUnit}
              exactChipValueUnit={players.exactChipValueUnit}
              formatCurrency={currency.formatCurrency}
              formatChipValueCurrency={currency.formatChipValueCurrency}
              copyState={settlement.copyState}
              onCopySummary={settlement.handleCopySummary}
            />
          ) : null}
        </CardContent>
      </Card>
    </div>
  );
}

export default App;
